import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLyftComponent } from './simple-icons-lyft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLyftComponent ],
    exports:      [ SimpleIconsLyftComponent ],
    bootstrap:    []
})
export class SimpleIconsLyftModule {}
